module.exports = new __parcel__URL__("Palikkatakomo.eafa76ec.avif").toString();